import React from 'react';
import { FiAlertTriangle, FiCopy, FiLogOut } from 'react-icons/fi';
import AppModal from '../../common/AppModal';
import { toast } from 'react-toastify';

const UnlinkConfirmation = ({ show, onHide, handleYes, authUrlData, accountInfo, setIsLoading }) => {
    const handleCopy = () => {
        const url = "https://myaccount.google.com/connections?gar=WzJd&continue=https%3A%2F%2Fmyaccount.google.com%2Fsecurity%3Fgar%3DWzJd%26hl%3Den_GB%26utm_source%3DOGB%26utm_medium%3Dact&hl=en_GB&utm_source=OGB&utm_medium=act";
        if (!navigator.clipboard) {
            try {
                const textarea = document.createElement('textarea');
                textarea.value = url;
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand('copy');
                document.body.removeChild(textarea);
                toast.success('URL copied to clipboard!');
            } catch (err) {
                console.error('Fallback copy failed:', err);
                toast.error('Failed to copy URL. Please copy manually.');
            }
            return;
        }
        navigator.clipboard.writeText(url)
            .then(() => { toast.success('URL copied to clipboard!'); })
            .catch((err) => {
                console.error('Clipboard API failed:', err);
                try {
                    const textarea = document.createElement('textarea');
                    textarea.value = url;
                    document.body.appendChild(textarea);
                    textarea.select();
                    document.execCommand('copy');
                    document.body.removeChild(textarea);
                    toast.success('URL copied to clipboard!');
                } catch (fallbackErr) {
                    console.error('Fallback copy failed:', fallbackErr);
                    toast.error('Failed to copy URL. Please copy manually.');
                }
            });
    };

    const footerContent = (
        <button className="app-modal-btn-cancel" type="button" onClick={onHide}>
            Cancel
        </button>
    );

    return (
        <AppModal
            show={show}
            onClose={onHide}
            icon={<FiLogOut size={17} color="#fff" />}
            title="Unlink this account?"
            subtitle="This action will redirect you to Google settings"
            maxWidth="560px"
            footer={footerContent}
        >
            {/* Warning banner */}
            <div className="eauth-warning-banner">
                <FiAlertTriangle size={15} />
                Are you sure you want to unlink this account? This will redirect you to Google settings.
            </div>

            {authUrlData && authUrlData.length > 0 ? (
                <div className="eauth-table-wrap">
                    <table className="eauth-table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {authUrlData.map((item, index) => (
                                <tr key={index}>
                                    <td>{accountInfo?.name || '-'}</td>
                                    <td>{accountInfo?.email || '-'}</td>
                                    <td>
                                        <div className="eauth-table-actions">
                                            <button
                                                className="eauth-btn-copy"
                                                onClick={handleCopy}
                                                title="Copy URL to clipboard"
                                            >
                                                <FiCopy size={11} style={{ marginRight: 5, verticalAlign: 'middle' }} />
                                                Copy URL
                                            </button>
                                            <button
                                                className="eauth-btn-unlink"
                                                onClick={handleYes}
                                                title="Unlink Account"
                                            >
                                                <FiLogOut size={11} style={{ marginRight: 5, verticalAlign: 'middle' }} />
                                                Unlink
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <div className="eauth-empty">No authorization data available.</div>
            )}
        </AppModal>
    );
};

export default UnlinkConfirmation;
